import React from "react";
import classes from "./CategoryCardBanner.module.css";
import { useNavigate } from "react-router-dom";
import ReactPlayer from "react-player";

const CategoryCardBanner = ({ dataItem, closeDrawer, main_category_id, sub_category_id }) => {
    const navigate = useNavigate();
    return (
        <div className={classes.main_card}
            onClick={() => {
                if (dataItem?.type === "game") {
                    navigate(`/game/${dataItem?.name}?game=${dataItem?.id}`)
                } else {
                    navigate(`/category/video/play`,{
                        state:{
                            video:dataItem
                        }
                    })
                }
            }}
        >
            <div className={classes.main_card_image}>
                {dataItem?.type === "game" ? (
                    <img
                        src={dataItem?.game_banner}
                        alt={dataItem?.name}
                        loading="lazy"
                        className={classes.main_card_img}
                    />
                ) : (
                    // <ReactPlayer
                    //   url={dataItem?.video_src}
                    //   width="100%"
                    //   height="100%"
                    //   muted
                    //   playing={false}
                    //   controls={false}
                    // />

                    <img
                        src={dataItem?.video_thumbnail}
                        alt={dataItem?.name}
                        loading="lazy"
                        className={classes.main_card_img}
                    />

                    // <video
                    //   src={dataItem?.video_src}
                    //   preload="metadata"
                    //   muted
                    //   playsInline
                    //   className={classes.main_card_img}
                    // />
                )}
            </div>
            <p className={classes.episode_number}>{dataItem?.name}</p>
        </div>
    );
};

export default CategoryCardBanner;
